var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTrash = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M6.496 1C5.676 1 5 1.676 5 2.496V3H2v1h1v8.5c0 .824.676 1.5 1.5 1.5h6c.824 0 1.5-.676 1.5-1.5V4h1V3h-3v-.504C10 1.676 9.324 1 8.504 1H6.496Zm0 1h2.008c.281 0 .496.215.496.496V3H6v-.504C6 2.215 6.215 2 6.496 2ZM4 4h7v8.5c0 .281-.219.5-.5.5h-6a.494.494 0 0 1-.5-.5V4Zm1 1v7h1V5H5Zm2 0v7h1V5H7Zm2 0v7h1V5H9Z",
  fill: "currentColor"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgTrash);
export default ForwardRef;